import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Mapping View flow guide.
export const materialsMapExistingUserSteps: WelcomeStep[] = [
  { key: "materials-map-whats-new", label: "What's new", centered: true },
];
